import { REQEXP_ONLY_NUMBERS } from '../constants'

export const stringToBoolean = (str: string) => str === 'true'

export const stringContainsOnlyNumbers = (str: string) =>
  str.match(REQEXP_ONLY_NUMBERS) !== null

export const stringContainsNbrOfNumbers = (str: string, nbr: number) =>
  str.match(new RegExp('^[0-9]{' + nbr + '}$')) !== null

export const replaceUnnecessarySpaces = (str: string) =>
  str.replace(/\s\s+/g, ' ').trim()
